var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import { Field } from "@ane/ui-components/lib/components/FormikFormFields/Field";
import { LoadPickSubscribers } from "./LoadPickSubscribers.js";
import { getProcessedSubscriberPersona } from "./Subscriber.utils.js";
class LoadPickSubscribersField extends Field {
  constructor() {
    super(...arguments);
    __publicField(this, "children", (fieldProps) => {
      const { meta, field } = fieldProps;
      return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        LoadPickSubscribers,
        __spreadProps(__spreadValues(__spreadValues({}, this.props), field), {
          errorMessage: meta.touched && meta.error || "",
          onChange: (items) => this._handleChange(fieldProps, items)
        })
      ) });
    });
    __publicField(this, "_handleChange", (props, items) => {
      const newItems = getProcessedSubscriberPersona(items);
      props.form.setFieldTouched(props.field.name, true, true);
      props.form.setFieldValue(props.field.name, newItems, true);
      if (!!this.props.onChange) {
        this.props.onChange(newItems);
      }
    });
  }
}
export {
  LoadPickSubscribersField
};
//# sourceMappingURL=LoadPickSubscribersField.js.map
